<app-wrapper-cabinet>
  <app-header-cabinet
    [shouldShowCompanyLogo]="shouldShowCompanyLogo()"
    [currentCompany]="currentCompany()"
    [licenseStatus]="licenseStatus()"
    [pluginConnected]="pluginConnected()"
    (toggleMobileSidebar)="onToggleSidebar()"
    (badgeClick)="badgeClick.emit()">
  </app-header-cabinet>

  <app-wrapper-content-cabinet>
    <app-sidenav-cabinet
      [isCollapsed]="isSidebarCollapsed"
      [isOpen]="isSidebarOpen"
      (toggleSidebar)="onToggleSidebar()"
      (closeSidebar)="closeSidebar()">
      @for (section of menuSections(); track section.heading) {
        <app-menu-section-cabinet [isCollapsed]="effectiveSidebarCollapsed" [isFullHeight]="false">
          @if (section.heading) {
            <app-menu-heading-cabinet [isCollapsed]="effectiveSidebarCollapsed">
              {{ section.heading }}
            </app-menu-heading-cabinet>
          }
          <app-menu-cabinet>
            @for (item of section.items; track item.route) {
              <app-menu-item-cabinet
                [routerLink]="item.route"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ exact: true }"
                [isCollapsed]="effectiveSidebarCollapsed"
                [tooltipText]="item.label"
                [badge]="item.badge">
                <span [innerHTML]="item.icon | safeHtml"></span>
                <span>{{ item.label }}</span>
              </app-menu-item-cabinet>
            }
          </app-menu-cabinet>
        </app-menu-section-cabinet>
      }
    </app-sidenav-cabinet>

    <app-content-cabinet>
      <router-outlet></router-outlet>
    </app-content-cabinet>
  </app-wrapper-content-cabinet>

  <app-footer-cabinet></app-footer-cabinet>
</app-wrapper-cabinet>
